import styled from 'styled-components';
import { GlobalToken } from 'antd';
import { CustomThemeToken } from '@/theme';

export const CTACardContainer = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  flex-wrap: wrap;
`;

export const CTACard = styled.div<{ theme: { token: GlobalToken } }>`
  border: 1px solid ${({ theme: { token } }) => token.colorSplit};
  border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
  padding: ${({ theme: { token } }) => token.margin}px;
  background: linear-gradient(100deg, rgba(34, 187, 232, 0.2) -77.34%, rgba(34, 187, 232, 0) 40.36%),
    ${({ theme: { token } }) => (token as CustomThemeToken).colorPrimaryGrDark || '#1b2d43'};
  display: flex;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  flex: 1;
  min-width: 300px;
  height: 100px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme: { token } }) => token.colorPrimary};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const CTACardContent = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  gap: ${({ theme: { token } }) => token.margin}px;
  align-items: center;
  flex: 1;
  min-width: 0;
`;

export const CTACardIcon = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CTACardText = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  flex: 1;
  min-width: 0;
`;

export const CTACardTitle = styled.div<{ theme: { token: GlobalToken } }>`
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  color: ${({ theme: { token } }) => token.colorText};
`;

export const CTACardSubtitle = styled.div<{ theme: { token: GlobalToken } }>`
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  color: ${({ theme: { token } }) => token.colorText};
`;

export const CTALinkButton = styled.button<{ theme: { token: GlobalToken } }>`
  background: transparent;
  border: none;
  padding: ${({ theme: { token } }) => token.paddingXXS}px ${({ theme: { token } }) => token.paddingXS}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${({ theme: { token } }) => token.colorPrimary};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  font-weight: 400;
  white-space: nowrap;
  flex-shrink: 0;
  height: 40px;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.6;
  }
`;
